const NOOP = () => {};
const registerEventHandler = NOOP;
const unregisterEventHandler = NOOP;

export { registerEventHandler, unregisterEventHandler };
